module.exports = __webpack_public_path__ + "static/media/iconClasses.ee6209cc.svg";